import { render } from "./SalesKpiCard.vue?vue&type=template&id=0770618a&scoped=true"
import script from "./SalesKpiCard.vue?vue&type=script&lang=js"
export * from "./SalesKpiCard.vue?vue&type=script&lang=js"

import "./SalesKpiCard.vue?vue&type=style&index=0&id=0770618a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0770618a"]])

export default __exports__